const sectionCode = "SPRO2";
const chartCode = "C030x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T30Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T30Procedures };
